import { render, staticRenderFns } from "./g-caption.vue?vue&type=template&id=aaa09dac&scoped=true"
import script from "./g-caption.vue?vue&type=script&lang=js"
export * from "./g-caption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa09dac",
  null
  
)

export default component.exports